import { CurrencyPipe, DatePipe } from "@angular/common";
import { Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { EntityType } from "@models/common/entity-type.enum";
import { Company } from "@models/companies/company";
import { ExternalSourceType } from '@models/integrations/external-source-type.enum';
import { IDetailTab } from "@models/ui-models/detail-tab";
import { SubMenuItem } from "@models/ui-models/section-form-menu";
import { NgbDropdown, NgbDropdownItem, NgbDropdownMenu, NgbDropdownToggle, } from "@ng-bootstrap/ng-bootstrap";
import {
  GeneratePayslipModalComponent
} from "@pages/companies/components/company-profile-page/components/generate-payslip/generate-payslip-modal.component";
import { DividerComponent } from "@shared/components/commons/divider/divider.component";
import { TooltipComponent } from "@shared/components/commons/tooltip/tooltip.component";
import {
  AdHocPaymentReminderComponent
} from "@shared/components/entity-profiles/ad-hoc-reminders/ad-hoc-payment-reminder/ad-hoc-payment-reminder.component";
import { AutoPayComponent } from "@shared/components/entity-profiles/auto-pay/auto-pay.component";
import {
  XpmCardProfileComponent
} from "@shared/components/entity-profiles/xpm-card-profile/xpm-card-profile.component";
import { DateAgoPipe } from "@shared/pipes/dateAgoPipe";
import { CompaniesApiService } from "@shared/services/companies-api.service";
import { ConfigSettingsService } from "@shared/services/config-settings.service";
import { ToastrService } from "ngx-toastr";
import { ModalFormsService } from "../../../../../../forms/services/modal-forms.service";
import { ICompanyProfileTabKeys } from "../../company-profile-page.component";

@Component({
  selector: 'app-company-profile-card',
  standalone: true,
  imports: [
    CurrencyPipe,
    DividerComponent,
    NgbDropdown,
    NgbDropdownItem,
    NgbDropdownMenu,
    NgbDropdownToggle,
    DatePipe,
    TooltipComponent,
    DateAgoPipe,
    XpmCardProfileComponent,
    AutoPayComponent
  ],
  providers: [],
  templateUrl: 'company-profile-card.component.html',
  styleUrl: 'company-profile-card.component.scss'
})
export class CompanyProfileCardComponent implements OnInit {
  @Input() companyProfile!: Company;
  @Input() disableControls = false;
  @Input() countPendingForm = 0;
  @Input() showXpm = false;

  @Output() openCompanyChangeNameForm = new EventEmitter<void>();
  @Output() onCompanyRefreshed = new EventEmitter<void>();
  @Output() onSelectTab = new EventEmitter<IDetailTab<ICompanyProfileTabKeys>>();
  private toastr = inject(ToastrService);
  private modalFormsService = inject(ModalFormsService);
  private companiesApiService = inject(CompaniesApiService);
  private configSettingsService = inject(ConfigSettingsService);
  ExternalSourceType = ExternalSourceType;
  entityType: EntityType = EntityType.Company;

  debtUpdatedDate = new Date();
  readonly refreshDebtMsg = 'Your request has been submitted. We are expecting ASIC\'s' +
    ' response soon. Once you\'ve received it, you\'ll be notified via the Alerts page.';
  companyDebtMenu: SubMenuItem[] = [];

  ngOnInit(): void {
    this.companyDebtMenu = this.getCompanyDebtMenuOptions();
  }

  onOpenCompanyChangeNameForm(): void {
    this.openCompanyChangeNameForm.emit();
  }

  onCompanyRefreshedEvent(): void {
    this.onCompanyRefreshed.emit();
  }

  refreshCompanyDebt(): void {
    alert(this.refreshDebtMsg);
  }

  generatePayslip(): void {
    // TODO: move to the company profile page
    const modalRef = this.modalFormsService.openModal(GeneratePayslipModalComponent, { size: 'lg', modalDialogClass: 'generate-payslip-modal' });
    const instance = modalRef.componentInstance as GeneratePayslipModalComponent;

    instance.companyProfile = this.companyProfile;
  }

  sendPaymentReminder(): void {
    // TODO: move to the company profile page
    const modalRef = this.modalFormsService.openModal(AdHocPaymentReminderComponent);
    const componentInstance = modalRef.componentInstance as AdHocPaymentReminderComponent;

    componentInstance.isAnnualReminder = false;
    componentInstance.company = this.companyProfile;
  }

  payDebt(): void {
    // TODO: move to the company profile page
    this.configSettingsService.getPaymentUrl().subscribe((url) => {
      window.open(url, '_blank');
    });
  }

  openDocumentsTab(): void {
    this.onSelectTab.emit({ title: 'Documents' } as IDetailTab<ICompanyProfileTabKeys>);
  }

  triggerRA71(): void {
    // TODO: move to the company profile page
    this.disableControls = true;

    this.companiesApiService.refreshInfo(this.companyProfile.entityId).subscribe({
      next: () => {
        this.toastr.success('Company profile refresh has been triggered and will update within a few minutes');
        this.disableControls = false;
      },
      error: () => {
        this.toastr.error('Failed to trigger company profile refresh');
        this.disableControls = false;
      }
    });
  }

  getCompanyDebtMenuOptions(): SubMenuItem[] {
    return [
      {
        title: 'Refresh Company Debt',
        iconClass: 'icon ic-refresh-20',
        action: () => this.refreshCompanyDebt()
      },
      {
        title: 'Generate a Payslip',
        iconClass: 'icon ic-generate-documents-20',
        action: () => this.generatePayslip()
      },
      {
        title: 'Send Payment Reminder',
        iconClass: 'icon ic-bell-20',
        disabled: !this.companyProfile?.companyDebt?.amountOwing,
        action: () => this.sendPaymentReminder()
      },
      {
        title: 'Pay Debt',
        iconClass: 'icon ic-debt-20',
        isVisable: () => !!this.companyProfile?.postBillpay,
        action: () => this.payDebt()
      },
    ];
  }
}

// Removed the unused `next` function.

